import { smoothScrollTo, getOffset } from '../../utilities/js/helper';

class Scroller {
    constructor (el, options) {
        const defaults = {
            offset: '0'
        };
        this.settings = Object.assign({}, defaults, options);
        this.scroller = el;
        this.offset = 0;
    }

    initialize () {
        this.setEvents();

        window.resizeHandler.customFunctions.push(() => {
            this.setEvents();
        });
    }

    setEvents () {
        this.offset = window.matchMedia('(max-width: 767px)').matches ? 70 : 184;

        this.scroller.addEventListener('click', (e) => {
            const scrollerId = this.scroller.getAttribute('href').split('#')[1];
            const $scrollerTarget = document.getElementById(scrollerId);

            if ($scrollerTarget !== null) {
                const scrollerTargetTop = getOffset($scrollerTarget).top - this.offset;
                smoothScrollTo(0, scrollerTargetTop);
            }

            e.preventDefault();
        });
    }
}

export { Scroller };
